import { render, staticRenderFns } from "./SectionSlides.vue?vue&type=template&id=a7733e0a&scoped=true&"
import script from "./SectionSlides.vue?vue&type=script&lang=ts&"
export * from "./SectionSlides.vue?vue&type=script&lang=ts&"
import style0 from "./SectionSlides.vue?vue&type=style&index=0&id=a7733e0a&lang=scss&scoped=true&"
import style1 from "./SectionSlides.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a7733e0a",
  null
  
)

export default component.exports